import React from "react";

// STYLES
import "./GenericButton.scss";

interface IGenericButtonProps {
    text: string;
    className?: string;
    onClick: () => void;
    disabled?: boolean;
    [key: string]: any; // rest
}

const GenericButton: React.FC<IGenericButtonProps> = ({
    text,
    className = "",
    onClick,
    disabled = false,
    ...rest
}) => {
    return (
        <button
            className={`GenericButton ${className} ${
                disabled ? "GenericButton-disabled" : ""
            }`}
            type="button"
            onClick={() => {
                onClick();
            }}
            disabled={disabled}
            {...rest}
        >
            {text}
        </button>
    );
};

export default GenericButton;
